export default __webpack_public_path__ + "static/media/Flag_of_Nicaragua.edc76ec6.svg";